import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

import { PDFDownloadLink } from "@react-pdf/renderer";

// Icons
import LocalMallIcon from '@material-ui/icons/LocalMall';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// Components
import InventoryItemTable from "./InventoryItemTableView";

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import MessageBox from "../../components/MessageBox/MessageBox";

//cookies
import {isLoggedIn} from "../../components/Cookies/Cookies";

//Modal
import LoadingModal from "../../components/Modal/LoadingModal";
import Preloader from "../../components/Preloader/Preloader";

import InvetoryAdjustmentPDF from "./InvetoryAdjustmentPDF"; //Component for exportation of inventory asdjustment PDF

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
		width: "calc(75% + 24px)"
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const ColorButton = withStyles(() => ({
	root: {
		color: "#fff",
		backgroundColor: "#4caf50",
		"&:hover": {
			backgroundColor: "#fff",
			color: "#4caf50",
		},
	},
}))(Button);



const InventoryAdjustmentHistoryView = (props) => {

	const { adjno, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(false);

	//state for managing loading modal
	const [showModal, setShowModal] = useState(false);

	let history = useHistory();

	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.itemid);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.itemid){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.itemid, 
				qty: item.qty,
				price: item.cost, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		// console.log(item_id);
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
			// console.log('refresh sir');
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty))
		setPoTotal(po_total);
		setPoTotal()
	}, [items]);

	const data = async () => {
		const params = {
			adjno: adjno || props.adjno,
			jc_u_idno: branchidno || props.branch_id
		};

		await axios.get(process.env.REACT_APP_API_URL+'inv_adjustment_form', { params }
		).then((res)=>{
			setSupplierInfo(res.data.data[0].general_info);
			setItems(res.data.data[1].item_info);
			setNotes(res.data.data[0].general_info.notes);
		}).catch((error)=>{
			// console.log(error.message);
		})
	};
	const DownloadPdf = (props) => {
		const classes = useStyles();
	
		const { adjno, location, adj_type, adjustment_date, items } = props;
		try {
		return(
			<PDFDownloadLink 
				document={
					<InvetoryAdjustmentPDF 
						data={{
							adjno,
							location, 
							adj_type, 
							adjustment_date, 
							items
						}}
					/>
				} 
				fileName={`Inventory-Adjustment-#${adjno}.pdf`}
			>
				{({ loading }) => {
					return (
						loading ? 
						"Loading" : 
						<ColorButton
							variant="contained"
							color="primary"
							classes={{
								root: classes.root,
								disabled: classes.disabled,
							}}
						>
							Export PDF
						</ColorButton>
					);
				}}
			</PDFDownloadLink>
		);
	} catch (err) {
		// console.log("Error generating PDF:", err);
		// setError("Failed to generate PDF. Please try again.");
	      }
	}

	return (
		<div className="page">
			{
				adjno ?
				<div className="page-header">
					<div className="page-icon">
						<LocalMallIcon />
					</div>
					<NavLink to={"/inventory"}><h2 style={{color:"black"}}>Inventory</h2></NavLink>
					<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
					<NavLink to={"/inventory/inventory-adjustment-history"}><h2 style={{color:"black"}}>Inventory Adjustment History</h2></NavLink>
					<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
					<h2>Inventory Adjustment History View #{adjno || props.adjno}</h2>

					<Button onClick={() => history.goBack()}>Go Back</Button>
				</div>
				 : 
				 <div className="page-header">
					<div className="page-icon">
						<LoyaltyTwoTone />
					</div>
					<NavLink to={"/inventory"}>
						<h2 style={{ color: "black" }}>Purchases</h2>
					</NavLink>
					<ArrowForwardIosIcon
						style={{ paddingLeft: "10px", paddingRight: "10px" }}
					/>
					<NavLink to={"/inventory/inventory-adjustment"}>
						<h2 style={{ color: "black" }}>Inventory Adjustment</h2>
					</NavLink>
					<ArrowForwardIosIcon
						style={{ paddingLeft: "10px", paddingRight: "10px" }}
					/>
					<h2>Inventory Adjustment #{adjno || props.adjno}</h2>
				</div> 
			}
			{supplierInfo?(<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12} sm={8}>
								<div className={classes.subTitle}>
									Inventory Adjustment History View
								</div>
								<div className={classes.title}>
									{supplierInfo.title || "Inventory Adjustment"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
					  </Grid>
					</div>
					<LoadingModal showModal={showModal}/>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={6}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={2} className={classes.infoTitle}>
											Location:
										</Grid>
										<Grid
											item
											xs={12}
											sm={10}
											className={classes.infoContent}
										>
											{supplierInfo.location || "Date of delivery"}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={2} className={classes.infoTitle}>
											Type: 
										</Grid>
										<Grid
											item
											xs={8}
											sm={10}
											className={classes.infoContent}
										>
											{supplierInfo.adjtype || "Deliver To"}
										</Grid>
									</Grid>
								</Grid>
								<Grid item xs={12} sm={6}>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Adjustment No:
										</Grid>
										<Grid
											item
											xs={12}
											sm={8}
											className={classes.infoContent}
										>
											{adjno || props.adjno}
										</Grid>
									</Grid>
									<Grid container spacing={3}>
										<Grid item xs={12} sm={4} className={classes.infoTitle}>
											Transaction Date:
										</Grid>
										<Grid
											item
											xs={12}
											sm={8}
											className={classes.infoContent}
										>
											{supplierInfo.adjustment_date || ""}
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</div>
						<InventoryItemTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					{ 
						(!supplierInfo.location || !supplierInfo.adjtype || !supplierInfo.adjustment_date || items.length > 0) ? 
							<DownloadPdf 
								adjno={adjno || props.adjno} 
								location={supplierInfo.location || ""}
								adj_type={supplierInfo.adjtype || ""}
								adjustment_date={supplierInfo.adjustment_date || ""}
								items={items}
							/> :
							''
					}
				</div>
			</div>
		):(<Preloader/>)}

		</div>
	);
};

export default InventoryAdjustmentHistoryView;
